<template>
  <div :style="{ padding: ' 10px', marginTop: '60px' }">
    <!-- <div v-for="list in routerVal" class="indexButton_baoming" @click="jump(list.active)">{{list.name}}</div> -->
    <!-- <div class="menutree">
      <ul>
        <li>
          <el-button type="primary" plain @click="toelement(0)">本科生报名</el-button>
        </li>
        <li>
          <el-button type="success" plain @click="toelement(1)">硕士报名</el-button>
        </li>
        <li>
          <el-button type="info" plain @click="toelement(2)">博士报名</el-button>
        </li>
        <li>
          <el-button type="warning" plain @click="toelement(3)">留学生报名</el-button>
        </li>
        <li>
          <el-button type="danger" plain @click="toelement(4)">成人教育报名</el-button>
        </li>
      </ul>
    </div> -->
    <div class="mainbox">
      <div class="cardbox" v-for="list in routerVal">
        <div class="cardboxtitle" :id="list.active">
          <p>{{ list.name }}</p>
        </div>
        <div class="cardboxcontentList">
          <div class="cardboxcontent">
            <template v-for="data in listdata">
              <div
                class="formbox"
                v-if="data.QStype == list.active"
                @click="jump(data.QStype, data.id, data.Printing)"
              >
                <div>
                  <p>{{ data.name }}</p>
                </div>

                <p>{{ data.time }}</p>
                <!-- <div @click="jump(data.QStype,data.id)">
                  <p>进入详情</p>
                  
                </div> -->
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="准考证查询"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
      class="add"
    >
      <el-input v-model="inputName" placeholder="请输入姓名" ></el-input>
     <div style="height:12px"></div>
      <el-input v-model="inputidcard" placeholder="请输入身份证"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            dialogVisible = false;
            copylistId = '';
          "
          >取 消</el-button
        >
        <el-button type="primary" @click="queryzkz()">查询</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      inputName: "",
      inputidcard: "",
      dialogVisible: false,
      routerVal: [
        { active: 0, path: "/HYregister", name: "本科生" },
        { active: 1, path: "/HYregister", name: "硕士研究生" },
        { active: 2, path: "/HYregister", name: "博士研究生" },
        { active: 3, path: "/HYregister", name: "留学生" },
        { active: 4, path: "/HYregister", name: "成人教育" },
      ],
      listdata: [],
    };
  },
  watch: {},
  methods: {
    handleClose(done) {
      done();
    },
    queryzkz(){
      this.$store.state.idcard = this.inputidcard;
      this.$http({
          method: "post",
          url: `/RegistrationMagt/api/Diyform/getApplyInfo`,
          params: {
            formid: this.$store.state.enrollFormId,
            idcard: this.$store.state.idcard,
          },
        })
          .then((res) => {
            if (res.data.response.data && res.data.response.data.length != 0) {
              this.dialogVisible = false;  
              this.$router.push("/HYregister");
            }else{
              this.$message({
              message: "未查询到数据",
              type: "error",
              duration: 3000,
            });
            }
          })
          .catch((_) => { });
    },
    jump(QStype, id, Printing) {
      //记录学生类型
      if (Printing == "1") {
        this.$store.state.QStype = QStype;
        this.$store.state.enrollFormId = id;
        this.dialogVisible = true;
      } else {
        this.$store.state.QStype = QStype;
        this.$store.state.enrollFormId = id
        this.$router.push("/HYregister");
      }
    },
    // 获取当前报名表
    getFormBycurrentVer(QStype) {
      this.$http({
        method: "post",
        url: `/RegistrationMagt/api/Diyform/getFormJson?type=${QStype}`,
      })
        .then((res) => {
          console.log(res);
          for (var i in res.data.response.data) {
            if (res.data.response.data[i].currentVer == 1) {
              // 有推送中的报名表  不显示提示

              // res.data.response.data[i].statime,
              // res.data.response.data[i].endtime

              this.listdata.push({
                QStype: QStype,
                name: res.data.response.data[i].tablename,
                time:
                  res.data.response.data[i].statime.replace("T", " ") +
                  "至" +
                  res.data.response.data[i].endtime.replace("T", " "),
                id: res.data.response.data[i].id,
                Printing: res.data.response.data[i].Printing,
              });
            }
          }
          console.log(this.listdata);
        })
        .catch((_) => { });
    },
    toelement(type) {
      document.getElementById(type).scrollIntoView(
        {
          behavior: "smooth", block: "end"  // 平滑过渡
        });
      console.log(document.getElementById(type))
    }
  },
  mounted() {
    this.getFormBycurrentVer(0);
    this.getFormBycurrentVer(1);
    this.getFormBycurrentVer(2);
    this.getFormBycurrentVer(3);
    this.getFormBycurrentVer(4);
  },
};
</script>
<style scoped>
.mainbox {
  width: 98%;
  /* background: black; */
  display: flex;
  flex-wrap: wrap;
  /* margin: auto; */
}
.cardbox {
  height: 140px;
  /* float: left; */
  display: flex;
  /* width: 46%; */
  width: 1250px;
  min-width: 800px;
  border-bottom: 1px solid #dcdfe6;
  margin: 10px auto;
}

.cardboxtitle {
  text-align: left;
  /* color: #2d76f9; */
  color: #525252;
  margin-bottom: 10px;
  float: left;
  position: relative;
  /* display: inline-block; */
  height: 140px;
  width: 180px;
  background: url("../assets/index/formTypetitle2.png") no-repeat top;
  background-size: auto 100%;
}

.cardboxtitle p {
  font-size: 20px;
  float: left;
  /* margin-left: 20px; */
  /* line-height: 0px; */
  position: relative;
  text-align: center;
  bottom: -80px;
  font-weight: 600;
  /* margin:0px 20%; */
  width: 100%;
  /* font-weight: 500px; */
}
.cardboxcontentList {
  width: 1200px;
  height: 150px;
  /* background: white; */
  overflow-x: auto;
  overflow-y: hidden;
  /* display: inline-block; */
  float: left;
}
.cardboxcontent {
  display: flex;
  /* flex-wrap:  wrap; */
  position: relative;
}
.formbox {
  height: 120px;
  width: 300px;
  float: left;
  background: white;
  /* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); */
  border: 1px solid #dcdfe6;
  margin: 10px 20px;
  cursor: pointer;

  /* flex盒子空间不足时，也不缩小，即定义的宽度有用 */
  flex-shrink: 0;
}
.formbox:hover {
  border: 1px solid #b0d2ff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  background: #f1f7ff;
}
.formbox > div:nth-of-type(1) {
  font-size: 16px;
  position: relative;
  font-weight: 600;
  height: 44px;
  padding: 0px 10px;
}
.formbox > p {
  /* font-weight: 600; */
  color: #828282;
  font-size: 12px;
  position: relative;
  top: 30px;
}
.formbox > div:nth-of-type(2) {
  height: 20px;
  border-top: 1px solid #dcdfe6;
  position: relative;
  top: 20px;
  color: #2d76f9;
  cursor: pointer;
  line-height: 0px;
}
ul {
  list-style: none;
}
.menutree {
  position: fixed;
  top: 80px;
  width: 100%;
  background: white;
  z-index: 2;
}
.menutree ul li {
  float: left;
  margin: 10px;
}
.menutree > ul {
  margin: auto;
  width: 650px;
  height: 80px;
  padding: 0px;
}

/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  border-radius: 10px;
  height: 12px;
  width: 12px;
  background-color: white;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  /* box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); */
  /* -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); */
  border: 1px solid #dcdfe6;
  /* border-radius: 10px; */
  background-color: white;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  /* border-radius: 10px; */
  /* box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1); */
  /* -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1); */
  background: #e2e2e2;
}
</style>